import React from "react";
import ServiceCardV2 from "../../components/PageSection/ServiceCard";

type ServiceCardData = {
  icon: string;
  title: string;
  content: string;
};

type ServiceCardsSectionProps = {
  title: string;
  cards: ServiceCardData[];
};

const ServiceCardsSection: React.FC<ServiceCardsSectionProps> = ({
  title,
  cards,
}) => {
  return (
    <section className="pt-80 pb-80">
      <div className="container">
        <h2 className="xb-section-title text-center wow fadeInUp">
          {title}
        </h2>

        <div className="row mt-40">
          {cards.map((card, i) => (
            <div
              className="col-lg-4 col-md-6 mb-30 wow fadeInUp"
              data-wow-delay={`${i * 80}ms`}
              key={i}
            >
              <ServiceCardV2
                icon={card.icon}
                title={card.title}
                content={card.content}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCardsSection;
